import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import Swal from 'sweetalert2'
import { printProfileCreditPdf, customerFromProfileRow } from '../../../utils/profileCreditPdf'
import { connect } from 'react-redux'

class CustomerCreditProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lists: [], total: 0, page: 1, is_search: false, isLoading: false
    }
  }

  componentDidMount() {
    this.loadList(1)
  }

  loadList(page) {
    this.setState({ isLoading: true, page })
    axios.get(APIURL + '/profile_credit/page/' + page)
      .then(res => {
        this.setState({
          lists: (res.data && res.data.rows) || [],
          total: (res.data && res.data.total) || 0,
          isLoading: false,
          is_search: false
        })
      })
      .catch(() => this.setState({ lists: [], isLoading: false }))
  }

  onSearch() {
    const q = (this.refs.search_input && this.refs.search_input.value) || ''
    if (!q) { this.loadList(1); return }
    this.setState({ isLoading: true, is_search: true })
    axios.get(APIURL + '/profile_credit/search/' + encodeURIComponent(q))
      .then(res => this.setState({ lists: res.data || [], isLoading: false }))
      .catch(() => this.setState({ lists: [], isLoading: false }))
  }

  // navigate to detail/form
  openDetail(id) {
    this.props.history.push('/customer/credit-profile-form?profile_credit_id=' + id)
  }

  goToDetailNew() {
    this.props.history.push('/customer/credit-profile-form')
  }

  // reload the list from scratch (clears any search)
  onRefresh() {
    if (this.refs.search_input) this.refs.search_input.value = ''
    this.loadList(1)
  }

  // print a single profile row's PDF (loads full record, then opens PDF)
  printRow(id) {
    axios.get(APIURL + '/profile_credit/' + id)
      .then(res => {
        const p = res.data || {}
        printProfileCreditPdf(p, customerFromProfileRow(p))
      })
      .catch(() => Swal.fire({ title: 'โหลดข้อมูลไม่สำเร็จ', type: 'error' }))
  }

  render() {
    const { lists, total, page, is_search } = this.state
    const all_page = Math.ceil(total / 20)
    const pages = Array.from(Array(all_page).keys()).map(p => p + 1)
    return (
      <div className="animated fadeIn">
        <div className="col-md-12 mb-4">
          <div className="card card-accent-primary">
            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>ข้อมูลเครดิตลูกค้า</strong>
              <div>
                <input ref="search_input" className="form-control d-inline-block" style={{ width: 220 }} placeholder="ค้นหา ชื่อ / เบอร์" />
                {' '}
                <button className="btn btn-sm btn-primary" onClick={() => this.onSearch()}><i className="icon-search"></i> ค้นหา</button>
                {' '}
                <button className="btn btn-sm btn-secondary" onClick={() => this.onRefresh()} title="รีโหลด"><i className="icon-refresh"></i></button>
                {' '}
                <button className="btn btn-primary" onClick={() => this.goToDetailNew()}><i className="icon-user-follow"></i> เพิ่มเครดิตลูกค้า</button>
              </div>
            </div>
            <div className="card-block">
              <table className="table table-striped">
                <thead><tr>
                  <th className="text-center">#</th><th>ชื่อลูกค้า</th><th>เบอร์</th>
                  <th className="text-center">สถานะ</th><th className="text-center">วันรับงาน</th><th></th>
                </tr></thead>
                <tbody>
                  {lists.map((r, i) => (
                    <tr key={r.profile_credit_id} style={{ cursor: 'pointer' }}
                        onClick={() => this.openDetail(r.profile_credit_id)}>
                      <td className="text-center">{(page - 1) * 20 + i + 1}</td>
                      <td>{r.customer_name} {r.customer_lastname}</td>
                      <td>{r.customer_mobile}</td>
                      <td className="text-center">
                        {r.credit_status === 'ปกติ' ? <span className="badge badge-success">ปกติ</span>
                         : (r.credit_status === 'ติด BL' || r.credit_status === 'ล่าช้า') ? <span className="badge badge-danger">{r.credit_status}</span>
                         : r.credit_status ? <span className="badge badge-warning">{r.credit_status}</span>
                         : <span className="badge badge-secondary">—</span>}
                      </td>
                      <td className="text-center">{r.received_date || '-'}</td>
                      <td className="text-right">
                        <button className="btn btn-sm btn-warning" onClick={e => { e.stopPropagation(); this.openDetail(r.profile_credit_id) }}><i className="fa fa-edit"></i> แก้ไข</button>
                        {' '}
                        <button className="btn btn-sm btn-info" onClick={e => { e.stopPropagation(); this.printRow(r.profile_credit_id) }} title="พิมพ์"><i className="icon-printer"></i></button>
                      </td>
                    </tr>
                  ))}
                  {lists.length === 0 && <tr><td colSpan="6" className="text-center text-muted">ไม่มีข้อมูล</td></tr>}
                </tbody>
              </table>
              {!is_search && (
                <ul className="pagination pagination-sm">
                  {pages.map(p => (
                    <li key={p} className={'page-item' + (p === page ? ' active' : '')}>
                      <button className="page-link" onClick={() => this.loadList(p)}>{p}</button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { user: state.auth && state.auth.user ? JSON.stringify(state.auth.user) : '{}' }
}
export default connect(mapStateToProps)(CustomerCreditProfile)
